<template>
  <v-menu offset-y
          nudge-left="80"
          :close-on-content-click="false"
          :nudge-width="100"
          v-model="menu"
          transition="slide-y-transition">

    <v-avatar class="transparent"
              slot="activator"
              size=30
              v-if="!onlyText">
      <v-icon dark>language</v-icon>
    </v-avatar>

    <v-btn slot="activator"
           :class="{'pr-4': showIcon, 'text-shadow':!showIcon}"
           :outline="withBorder"
           v-else
           :round="withBorder"
           :color="color"
           small
           flat>
      <v-icon v-if="showIcon">arrow_drop_down</v-icon>
      {{ currentLanguage }}
    </v-btn>

    <v-list>
      <v-list-tile v-for='item in langsFiltered'
                   :key='item.key'
                   :value='item.key'
                   @click='changeLanguage(item, false)'>
        <v-list-tile-title>{{ item.langName }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import store from '@/store';
import _ from 'lodash';

export default {
  name: 'ChangeLanguageDropdown',
  props: {
    onlyText: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    withBorder: {
      type: Boolean,
      required: false,
      default: false
    },
    updateLanguageOnCreated: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    langsFiltered() {
      return _.filter(this.items, it => {
        return it.langName !== store.state.langSelected.langName;
      });
    },
    currentLanguage() {
      return store.state.langSelected.langName;
    }
  },
  data() {
    return {
      menu: false,
      items: [],
      allLanguages: [],
      localeSelected: this.$i18n.locale
    };
  },
  created() {
    _.each(store.state.langs, obj => {
      this.allLanguages.push(_.merge({ key: obj.langIso }, obj));
    });

    if (this.updateLanguageOnCreated) {
      this.updateLanguages();
    }
  },

  destroyed() {},

  methods: {
    updateLanguages() {
      this.items = _.intersectionWith(this.allLanguages, store.state.countrySelected.languages, (itAll, ctyLang) => {
        return itAll.key === ctyLang.langIso;
      });

      let langSelected = this.items[0];

      if (typeof store.state.langSelected !== 'undefined') {
        langSelected = store.state.langSelected;
      }

      this.changeLanguage(langSelected);
    },
    changeLanguage(langSelected) {
      this.$i18n.locale = langSelected.langIso;
      this.localeSelected = langSelected.langIso;

      if (langSelected.langIso !== store.state.langSelected.langIso || _.includes(['HomePage', 'GodfatherPage', 'FaqPage'], this.$route.name)) {
        store.commit('CHANGE_LANG_SELECTED', { langSelected: this.localeSelected });
      }

      this.menu = false;
    }
  }
};
</script>
